import { AfterViewInit, Component, Input, OnInit, Renderer2, ViewChild, TemplateRef } from '@angular/core';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Status } from '../../../enums/status';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { StihlUserDTO } from 'src/app/models/stihl-user-dto';
import { CampaignOrderService } from 'src/app/services/campaign-order.service';
import { SharedService } from 'src/app/services/shared.service';
import { LanguageApp } from 'src/app/config/datatable-config';
import { Helpers } from 'src/app/helpers/helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { heightContentAnimation } from 'src/app/animations';


@Component({
  selector: 'app-table-order-crm',
  templateUrl: './table-order-crm.component.html',
  animations: [heightContentAnimation]
})
export class TableOrderCrmComponent implements AfterViewInit, OnInit {
  @Input() Origin: string = "";
  hdd_origin: string;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild('content', { read: TemplateRef }) content: TemplateRef<any>;

  listenerFn: () => void;
  actualStatus: number;
  actualOrder: string;
  loggedUser: StihlUserDTO = new StihlUserDTO();
  totalCampaignCount: any;

  public distributorsList: any[] = [];
  public statusList: any[] = [];
  defaultStatus: string = '0';
  defaultDistrib: string = '0';

  constructor(
    private campaignOrderService: CampaignOrderService,
    private router: Router,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private helper: Helpers,
    private userService: UserService,
    private sharedService: SharedService,
    private modalService: NgbModal
  ) {

  }

  ngAfterViewInit(): void {

    this.listenerFn = this.renderer.listen('document', 'click', (event) => {


      if (event.target.hasAttribute("approve-id")) {
        this.actualOrder = event.target.getAttribute("approve-id");
        this.approveCampaing(this.actualOrder);
      }

      if (event.target.hasAttribute("edit-order-id")) {
        this.actualOrder = event.target.getAttribute("edit-order-id");

        this.campaignOrderService.getOrderCrmById(this.actualOrder).subscribe(resp => {

          const modelCampaingMaterialCrm = resp;

          this.router.navigate(["/campaign/material"], { queryParams: { 'idCampaign': modelCampaingMaterialCrm.IdCampaign, 'idMaterialMedia': modelCampaingMaterialCrm.IdCampaignMaterialMedia, 'idOrder': this.actualOrder, retorno: 'admin' } });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro'
          });
        });

      }

      if (event.target.hasAttribute("pausar-order-id")) {
        this.actualOrder = event.target.getAttribute("pausar-order-id");
        this.pausedCampaing(this.actualOrder);
      }

      if (event.target.hasAttribute("continue-order-id")) {
        this.actualOrder = event.target.getAttribute("continue-order-id");
        this.continueCampaing(this.actualOrder);
      }

      if (event.target.hasAttribute("view-order-id")) {
        this.router.navigate(["/myarea/orders-crm/edit/" + event.target.getAttribute("view-order-id")]);
      }

      if (event.target.hasAttribute("send-mail-order-id")) {
        this.actualOrder = event.target.getAttribute("send-mail-order-id");
        this.modalService.open(this.content);
        // this.showModalEmail = true;

      }

      if (event.target.hasAttribute("delete-id")) {
        this.actualOrder = event.target.getAttribute("delete-id");
        this.bajaCampaingOrder(this.actualOrder);
      }

      if (event.target.hasAttribute("statistics-order-id")) {
        this.actualOrder = event.target.getAttribute("statistics-order-id");
        if (this.Origin == "stihl")
          this.router.navigate(["/area-stihl/orders-crm/statistics/" + event.target.getAttribute("statistics-order-id")]);
        if (this.Origin == "miArea")
          this.router.navigate(["/myarea/orders-crm/statistics/" + event.target.getAttribute("statistics-order-id")]);
        if (this.Origin == "adm")
          this.router.navigate(["/adm/order-crm-sender/statistics/" + event.target.getAttribute("statistics-order-id")]);
      }
    });
    this.helper.setDataTableSearchDelay();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  ngOnInit(): void {

    this.getLists();

    this.setDatatable();
    this.hdd_origin = this.Origin;

  }

  getLists() {
    this.sharedService.getStihlCustomStatus([Status.Aprobado, Status.EnProceso, Status.PendienteDeAprobar, Status.Enviado, Status.Pausado, Status.Error]).subscribe(res => {

      res.unshift({ value: '0', label: 'TODOS OS ESTADOS' });
      this.statusList = res;
      this.defaultStatus = '0';

    });

    this.sharedService.getStihlDistributors().subscribe(res => {

      res.unshift({ value: '0', label: 'TODOS OS CONCESSIONÁRIOS' });
      this.distributorsList = res;
      this.getUser();

    });
  }

  getUser() {

    this.userService.getUserData().subscribe(res => {

      this.loggedUser = res;

      if (this.Origin != 'miArea') {
        this.defaultDistrib = '0';
      }
      else {
        this.defaultDistrib = this.loggedUser.IdDistributor.toString();
      }


      this.dtTrigger.next(null);


    });
  }

  rerender(): void {
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
    this.getCampaignCountData();
  }


  setDatatable() {
    const that = this;
    that.dtOptions = {
      responsive: false,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        // NO SÉ POR QUÉ A VECES DA NAN EN ESTE PUNTO.
        that.campaignOrderService.getDatatableOrderCrm(dataTablesParameters, isNaN(+that.defaultDistrib) ? 0 : +that.defaultDistrib, isNaN(+that.defaultStatus) ? 0 : +that.defaultStatus).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro'
          });

        });
      },
      columns: [
        { data: "codDistributor", orderable: false },
        { data: "Distributor", orderable: false },
        { data: "User", orderable: false },
        { data: "Number", orderable: false },
        { data: "Date", orderable: false },
        { data: "Campaign", orderable: false },
        { data: "CantidadUsuarios", orderable: false },
        { data: "Media", orderable: false },
        { data: "Status", orderable: false },
        { data: "DesiredDate", orderable: false },
        { data: "IdCampaignOrderCrm", orderable: false },
      ],
      columnDefs: [
        {
          targets: [0],
          data: "codDistributor",
        },
        {
          targets: [3],
          data: "Number",
          className: "text-center"
        },
        {
          targets: [4],
          data: "Date",
          className: "text-center"
        },
        {
          targets: [5],
          data: "Campaign",
          className: "text-center"
        },
        {
          targets: [6],
          data: "CantidadUsuarios",
          className: "text-center"
        },
        {
          targets: [7],
          data: 7,
          render: (data, type, row, meta) => {
            if (type === 'display') {
              // Reemplazar "EMAIL" con "E-MAIL"
              return data === 'EMAIL' ? 'E-MAIL' : data;
            } else {
              return data;
            }
          },
          className: "text-center"
        },
        {
          targets: [8],
          data: "status",
          className: "text-center text-uppercase",
          render: function (data, type, full) {
            var retorno = "";
            if (full.IdStatus == Status.PendienteDeAprobar) {
              retorno += '<div class="badge bg-primary">' + data + '</div>';
            }
            if (full.IdStatus == Status.Aprobado) {
              retorno += '<div class="badge bg-success">' + data + '</div>';
            }
            if (full.IdStatus == Status.Enviado) {
              retorno += '<div class="badge bg-success">' + data + '</div>';
            }
            if (full.IdStatus == Status.EnProceso) {
              retorno += '<div class="badge bg-danger">' + data + '</div>';
            }
            if (full.IdStatus == Status.Pausado) {
              retorno += '<div class="badge bg-danger">' + data + '</div>';
            }
            if (full.IdStatus == Status.Error) {
              retorno += '<div class="badge bg-danger">' + data + '</div>';
            }
            return retorno;
          }

        },
        {
          targets: [9],
          data: "DesiredDate",
          className: "text-center"
        },
        {
          targets: [10],
          data: "IdCampaignOrderCrm",
          render: function (data, type, full) {
            var retorno = '';

            const origin = document.getElementById("hddn_origin_crm")["value"];

            retorno += '<a send-mail-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_inbox_auto.svg#img" href="assets/images/icons/ico_inbox_auto.svg#img"></use></svg></div> Teste de envio</a>';

            if (origin == "miArea" || origin == "stihl") {
              retorno += '<a view-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_eye_auto.svg#img" href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Ver</a>';
            }

            if (origin == "stihl") {

            }

            if (origin == "adm") {
              retorno += '<a delete-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_trash_auto.svg#img" href="assets/images/icons/ico_trash_auto.svg#img"></use></svg></div> Eliminar</a>';

              if (full.IdStatus == Status.PendienteDeAprobar) {
                retorno += `<a approve-id="${data}" class="btn-transparent btn-sm btn-icon">${icon(faPaperPlane).html.join('')} Enviar</a>`;

              }

              // if (full.IdStatus == Status.PendienteDeAprobar || full.IdStatus == Status.Pausado) {
              //   retorno += '<a edit-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_eye_auto.svg#img" href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Editar</a>';
              // }

              if (full.IdStatus == Status.Enviado || full.IdStatus == Status.Aprobado || full.IdStatus == Status.PendienteDeAprobar) {
                retorno += '<a view-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_eye_auto.svg#img" href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Ver</a>';
              }

              if (full.IdStatus == Status.EnProceso) {
                retorno += '<a pausar-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_pause_auto.svg#img" href="assets/images/icons/ico_pause_auto.svg#img"></use></svg></div> A enviar...</a>';
              }

              if (full.IdStatus == Status.Pausado) {
                retorno += '<a continue-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_play_auto.svg#img" href="assets/images/icons/ico_play_auto.svg#img"></use></svg></div> Continuar...</a>';
              }

            }

            if (full.IdStatus == Status.Enviado) {
              retorno += '<a statistics-order-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_graph_auto.svg#img" href="assets/images/icons/ico_graph_auto.svg#img"></use></svg></div> Estatística</a>';
            }

            return retorno;
          }
        },

      ],
      initComplete: function () {
        that.getCampaignCountData();
        that.helper.animateDataTable(this[0])
      }
    };

  }

  getCampaignCountData() {
    console.log('getCampaignCountData');
    this.campaignOrderService.getCampaignCountData(+this.defaultStatus, this.defaultDistrib).subscribe(resp => {
      this.totalCampaignCount = resp;
    });
  }


  approveCampaing(idOrder) {
    Swal.fire({
      title: 'Aprovação',
      text: "Tem certeza de que pretende continuar e enviar o pedido de E-mail e SMS?",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      confirmButtonText: 'Aceitar',
      cancelButtonText: "Cancelar",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.campaignOrderService.changeStatusOrderCrm(idOrder, Status.Aprobado).subscribe(i => {
          this.rerender();
          Swal.fire(
            'Aprovado!',
            'O pedido selecionado foi aprovado.',
            'success'
          )
        })
      }
    })
  }

  continueCampaing(idOrder) {
    Swal.fire({
      title: 'Continuar',
      text: "Pretende avançar com o pedido de e-mail e SMS?",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      confirmButtonText: 'Aceitar',
      cancelButtonText: "Cancelar",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.campaignOrderService.changeStatusOrderCrm(idOrder, Status.Aprobado).subscribe(i => {
          this.rerender();
          Swal.fire(
            'Continuar!',
            'Continuar com o pedido selecionado.',
            'success'
          )
        })
      }
    })
  }

  pausedCampaing(idOrder) {
    Swal.fire({
      title: 'Suspender',
      text: "Tem certeza de que pretende continuar e suspender o pedido de E-mail e SMS?",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      confirmButtonText: 'Aceitar',
      cancelButtonText: "Cancelar",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.campaignOrderService.changeStatusOrderCrm(idOrder, Status.Pausado).subscribe(i => {
          this.rerender();
          Swal.fire(
            'Suspenso',
            'O pedido selecionado foi suspenso.',
            'success'
          )
        })
      }
    })

  }

  bajaCampaingOrder(idOrder) {
    Swal.fire({
      title: 'Eliminar',
      text: "Tem certeza de que pretende continuar e remover o pedido de E-mail e SMS?",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      confirmButtonText: 'Aceitar',
      cancelButtonText: "Cancelar",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.campaignOrderService.changeStatusOrderCrm(idOrder, Status.Baja).subscribe(i => {
          this.rerender();
          Swal.fire(
            'Removido!',
            'O pedido selecionado foi removido.',
            'success'
          )
        })
      }
    })

  }


  emailTest: string = "";
  // showModalEmail = false;
  showErrorEmailNoValid = "";

  closeModal() {
    this.emailTest = "";
    this.showErrorEmailNoValid = "";
    // this.showModalEmail = false;
    this.modalService.dismissAll();
  }


  sendEmailTest() {
    if (this.emailTest == "") {
      this.showErrorEmailNoValid = "Deve inserir um contacto válido.";
      return;
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'A enviar, Aguarde por favor…'
    });
    this.campaignOrderService.SendTestCrmByIdOrder(this.actualOrder, this.emailTest).subscribe(res => {
      Swal.close();
      this.toastr.success("O teste foi enviado com sucesso.");
      this.closeModal();
    });
  }
}
